import React from 'react';
import Maps  from './Maps';

function InfoPratique() {

  return(
    <div id="infos-pratiques" className='g-container-info-pratique'>
        <div className='container-adresse'>
            <div className="adresse">
            <h2>Où s'entrainer ?</h2>
                <p>Vieux gymnase des Garcins. Albert Bourges.<br></br> 05100 Briançon <br></br> France</p>
            </div>
            <Maps />
        </div>
        <div className='container-heure'>
            <div ></div>
            <div className="container-heure-texte">
            <div className="heure-texte">
                <h2>A quelle heure ?</h2>
                    <p><b>Mercredi :</b> 19h30-22h</p>
                    <p><b>Vendredi :</b> 18h30-21h</p>
            </div>
            </div>
        </div>
        <div className='separate-bar'></div>
    </div>
  )
}

export default InfoPratique;